import { observer } from 'mobx-react';

import EmptyPlaceholder from '@/common/components/EmptyPlaceholder/EmptyPlaceholder';

import styles from './EmptyTreePlaceholder.module.css';

interface EmptyTreePlaceholderProps {
  isTreeFilteredOut: boolean;
}

function EmptyTreePlaceholder(props: EmptyTreePlaceholderProps) {
  const { isTreeFilteredOut } = props;

  if (isTreeFilteredOut) {
    return (
      <EmptyPlaceholder className={styles.emptyTreePlaceholder}>
        No items meet the current filter criteria
      </EmptyPlaceholder>
    );
  }

  return (
    <EmptyPlaceholder className={styles.emptyTreePlaceholder}>
      You don’t have any items
      <br />
      Add one to proceed
    </EmptyPlaceholder>
  );
}

export default observer(EmptyTreePlaceholder);
